import axios from '@/services/axios'
import { getHeadersWithAccessToken } from '@/auth/tokenService'
import baseURLs from '@/api/APIBaseURLs'

export async function GetStrategyCubes () {
  const url = baseURLs.manageAPI + '/strategy_cubes'

  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data.data)
    .catch(console.error)
}

export async function GetStrategySeasons () {
  const url = baseURLs.manageAPI + '/strategy_seasons'

  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data.data)
    .catch(console.error)
}

export async function GetCubesBrowser () {
  const url = baseURLs.logicAPI + '/cube_browser'

  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data)
    .catch(console.error)
}

export async function getExternalCubes () {
  const url = baseURLs.manageAPI + '/data/buy/manage/get_budgets_external_keys'

  return axios.get(url, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data?.data)
    .catch(console.error)
}

export async function GetCubeInputData (cube_key, version_key) {
  const url = baseURLs.logicAPI + '/cube_browser'
  return axios.post(url, {
    cube_key: cube_key,
    version_key: version_key
  }, {
    headers: getHeadersWithAccessToken(),
  }).then(response => response.data).catch(console.error)
}

export async function LoadComparison (payload) {
  const url = baseURLs.logicAPI + '/cube_comparison'

  return axios
    .post(url, payload, {
      headers: getHeadersWithAccessToken(),
    })
    .then(response => {
      return response.data
    })
}

export async function LoadComparison2 (payload) {
  const url = baseURLs.logicAPI + '/cube_comparison_2'

  return axios
    .post(url, payload, {
      headers: getHeadersWithAccessToken(),
    })
    .then(response => {
      return response.data
    })
}

export async function PerformAction (payload) {
  const url = baseURLs.logicAPI + '/cube_action'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function GetCubeIntake (payload, signal) {
  const url = baseURLs.logicAPI + '/cube_intake'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken(),
    signal,
  }).then(response => response.data)
}

export async function GetCubeIntakeV2 (payload, signal) {
  const url = baseURLs.logicAPI + '/cube_intake_2'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken(),
    signal,
  }).then(response => response.data)
}

export async function GetCubeCollection (payload) {
  const url = baseURLs.logicAPI + '/cube_collection'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function GetCubeSimulation (payload) {
  const url = baseURLs.logicAPI + '/cube_simulation'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function GetCubeWSSI (payload) {
  const url = baseURLs.logicAPI + '/cube_wssi_2'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}
export async function GetCubeWSSINew (payload) {
  const url = baseURLs.logicAPI + '/cube_wssi'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function GetCubeDownloadLink (payload) {
  const url = baseURLs.logicAPI + '/cube_download'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function LoadCubeDimensionComparison (payload) {
  const url = baseURLs.logicAPI + '/cube_dimension_comparison'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function UploadDataFile (cubeKey, versionKey, formData) {
  const url = baseURLs.logicAPI + `/cube_upload?cube_key=${cubeKey}&version_key=${versionKey}`

  return axios.post(url, formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export async function GetCubeImpacts (payload) {
  const url = baseURLs.logicAPI + '/cube_impacts'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  }).then(response => response.data)
}

export async function UpdateStrategyCube (payload) {
  const url = baseURLs.manageAPI + '/strategy_cubes'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data.data)
    .catch(error => {
      console.error('Error updating cube:', error)
    })
}

export async function DeleteStrategyCube (cubeKey) {
  const url = baseURLs.manageAPI + '/strategy_cubes'

  return axios.delete(url, {
    headers: getHeadersWithAccessToken(),
    data: { cube_key: cubeKey }
  })
    .then(response => response.data.data)
    .catch(error => {
      console.error('Error deleting cube:', error)
      throw error
    })
}

export async function UpdateStrategySeason (payload) {
  const url = baseURLs.manageAPI + '/strategy_seasons'

  return axios.post(url, payload, {
    headers: getHeadersWithAccessToken()
  })
    .then(response => response.data.data)
    .catch(error => {
      console.error('Error updating season:', error)
    })
}

export async function DeleteStrategySeason (seasonKey) {
  const url = baseURLs.manageAPI + '/strategy_seasons'

  return axios.delete(url, {
    headers: getHeadersWithAccessToken(),
    data: { season_key: seasonKey }
  })
    .then(response => response.data.data)
    .catch(error => {
      console.error('Error deleting season:', error)
    })
}
